import {
  AidBreakdown,
  NormalizedStudentProfile,
} from "./types";
import { estimateAidPre2026 } from "./estimateAidPre2026";
import { estimateAidPost2026 } from "./estimateAidPost2026";

export interface PolicyComparison {
  pre2026: AidBreakdown;
  post2026: AidBreakdown;
  grantDifference: number;
  loanDifference: number;
  totalAidDifference: number;
  unmetNeedDifference: number;
}

function roundToTwo(value: number): number {
  return Math.round(value * 100) / 100;
}

export function comparePolicies(
  profile: NormalizedStudentProfile
): PolicyComparison {
  const pre2026 = estimateAidPre2026(profile);
  const post2026 = estimateAidPost2026(profile);

  return {
    pre2026,
    post2026,
    grantDifference: roundToTwo(post2026.grants - pre2026.grants),
    loanDifference: roundToTwo(post2026.loans - pre2026.loans),
    totalAidDifference: roundToTwo(post2026.totalAid - pre2026.totalAid),
    unmetNeedDifference: roundToTwo(post2026.unmetNeed - pre2026.unmetNeed),
  };
}